<template>
    <!-- 图标解释组件 当convert库图标发生改变时这里的图标也会发生改变 因此依赖convert-->
    <!-- 注意： 使用前必须给父级设置定位 -->
    <el-popover placement="left" width="500" trigger="hover" ref="iconTip" style="z-index:120">
        <div>
            <h1 style="font-size: 18px;font-weight:bold">{{ $t('public.icon_desc') }}:</h1>
            <span v-for="(item, index) in iconDesc" :key="index">
                <h2 style="line-height:40px">{{ $t(item.title) }}:</h2>
                <div class="tipIcon">
                    <div v-for="(iconItem, iconIdx) in icon[item.type]" :key="iconIdx">
                        <span>{{ $t(iconItem.title) }}</span
                        >:
                        <i :class="iconItem.icon" :title="$t(iconItem.title)" class="cursor-pointer" v-icon:theme></i>
                    </div>
                </div>
            </span>
        </div>
        <i class="el-icon-question question" slot="reference"></i>
    </el-popover>
</template>
<script>
import { icon } from '@/utils/convert';
export default {
    props: {
        iconDesc: {
            type: Array,
            // 示例传参
            default: () => {
                return [
                    {
                        // 图标解释标题
                        title: 'public.carrier_run_status',
                        // 图标类型
                        type: 'carrierStatus'
                    },
                    {
                        title: 'business.isTraceable',
                        type: 'trace'
                    },
                    {
                        title: 'integration.alarm_or_not',
                        type: 'isAlarm'
                    },
                    {
                        title: 'business.is_abnormal',
                        type: 'isCarrierAbnormal'
                    }
                ];
            }
        }
    },
    data() {
        return {
            icon
        };
    }
};
</script>

<style lang="scss" scoped>
.tipIcon {
    display: flex;
    flex-wrap: wrap;
    line-height: 40px;
    i {
        margin-right: 20px;
    }
}
.question {
    bottom: 15px;
    font-size: 18px;
    cursor: pointer;
    color: #9bccfd;

    &:hover {
        color: var(--primary-color);
    }
}
</style>
